import { render, staticRenderFns } from "./nuevaProp.vue?vue&type=template&id=489cd9f4"
import script from "./nuevaProp.vue?vue&type=script&lang=js"
export * from "./nuevaProp.vue?vue&type=script&lang=js"
import style0 from "./nuevaProp.vue?vue&type=style&index=0&id=489cd9f4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports